import BrowserRouter from '@empiriecom/module-components/BrowserRouter';
import React from 'react';
import { hydrate } from 'react-dom';
import { DataProvider, createDataClient } from 'react-isomorphic-data';
import 'unfetch/polyfill';
import App from '../components/App';

const namespace = process.env.FRAGMENT_NAMESPACE || 'og-emma';

const dataClient = createDataClient({
  // eslint-disable-next-line no-underscore-dangle
  initialCache: (window as any).__cacheProduct || {},
  ssr: false,
});

const isBot = document.getElementById(namespace).hasAttribute('data-bot');

hydrate(
  <DataProvider client={dataClient}>
    <BrowserRouter>
      <App isBot={isBot} />
    </BrowserRouter>
  </DataProvider>,
  document.getElementById(namespace),
);

if (module.hot) {
  module.hot.accept();
}
